const GOOGLE_PLACES_API_KEY = import.meta.env.VITE_GOOGLE_PLACES_API_KEY;
const VITE_SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const BASE_URL = import.meta.env.VITE_STRAPI_URL ?? "http://localhost:1337";
const TOKEN = import.meta.env.VITE_STRAPI_API_TOKEN as string | undefined;
const VITE_SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;
const GOOGLE_OAUTH_REDIRECT_URI =
	import.meta.env.VITE_GOOGLE_REDIRECT_URI ??
	(typeof window !== "undefined"
		? `${window.location.origin}/oauth/callback`
		: "/oauth/callback");

export {
	GOOGLE_PLACES_API_KEY,
	BASE_URL,
	TOKEN,
	VITE_SUPABASE_URL,
	VITE_SUPABASE_ANON_KEY,
	GOOGLE_OAUTH_REDIRECT_URI,
};
